<div class="embed-menu-container">
  <ng-container *ngIf="interactType == 'ModifiedInteractive' && !printPreview_IsActive">
    <div class="embed-menu-item">
      <a
        href="#"
        (click)="showMenu()"
        style="text-decoration: none; color: white"
      ><i class="fas fa-bars"></i><span>Interactive Menu</span></a
      >
    </div>
  </ng-container>
  <div *ngIf="userState.preFilters?.length >= 1 && !printPreview_IsActive" class="embed-menu-item">
    <a
      href="#"
      [matMenuTriggerFor]="preFiltersMenu"
      style="text-decoration: none; color: white"
      (click)="returnFalse()"
    ><i class="fa fa-filter"></i><span> Pre Filters</span></a>
  </div>
  <div class="embed-menu-item" *ngIf="!printPreview_IsActive && !editingLayout">
    <a
      href="#"
      [matMenuTriggerFor]="filtersMenu"
      style="text-decoration: none; color: white"
      (click)="returnFalse()"
    ><i class="fa fa-filter"></i><span>Filters</span></a
    >
  </div>
  <div class="embed-menu-item" *ngIf="!printPreview_IsActive">
    <a
      href="#"
      [matMenuTriggerFor]="bookmarksMenu"
      style="text-decoration: none; color: white"
      (click)="returnFalse()"
    ><i class="fa fa-bookmark"></i><span>Bookmarks</span></a
    >
  </div>
  <ng-container *ngIf="currentInteractive?.allowPrintOnDemand && !printPreview_IsActive">
    <div class="embed-menu-item">
      <a href="#" [matMenuTriggerFor]="podMenu" style="text-decoration: none; color: white" (click)="returnFalse()"><i class="fa fa-print"></i><span>Reports</span></a>
    </div>
  </ng-container>
  <ng-container *ngIf="reportService?.interactReports?.length > 0 && !printPreview_IsActive">
    <div class="embed-menu-item">
      <a
        href="#"
        [matMenuTriggerFor]="reportsMenu"
        style="text-decoration: none; color: white"
        (click)="returnFalse()"
      ><i class="fa fa-file"></i><span>Reports</span></a
      >
    </div>
  </ng-container>
  <div class="embed-menu-item" *ngIf="!printPreview_IsActive && !editingLayout">
    <a
      href="#"
      [matMenuTriggerFor]="interactivesMenu"
      style="text-decoration: none; color: white"
      (click)="returnFalse()"
    ><i class="fas fa-chart-bar"></i><span>Interactives</span></a
    >
  </div>
  <!-- <ng-container *ngIf="interactReportExports.length > 0">
    <div class="embed-menu-item">
      <a href="#" [matMenuTriggerFor]="reportExportsMenu" style="text-decoration: none; color: white;" (click)="showReportExportsMenu();"><i class="fa fa-clipboard-check"></i><span>Existing Exports</span></a>
    </div>
  </ng-container> -->
  <div class="embed-menu-item">
    <a *ngIf="showCloseButton" href="#" style="text-decoration: none; color: white" (click)="closeLinkClicked()">
      <i class="fa fa-window-close"></i>
      <ng-container *ngIf="!editingLayout">
        <span> Return To Admin</span>
      </ng-container>
      <ng-container *ngIf="editingLayout">
        <span> Back To Layouts</span>
      </ng-container>
    </a>
  </div>
  <div class="embed-menu-expander"></div>
  <ng-container *ngIf="reportService?.activeReport !== null && !printPreview_IsActive">
    <div class="embed-menu-item">
      <a
        href="#"
        style="text-decoration: none; color: white"
        (click)="reportService.cancelExport()"
      ><i class="fa fa-window-close"></i><span>Cancel Report</span></a
      >
    </div>
    <div class="embed-menu-item">
      <ng-container *ngIf="!reportService.firstPage">
        <a
          href="#"
          style="text-decoration: none; color: white"
          (click)="reportService.showPrevPage()"
        ><i class="fa fa-arrow-left"></i><span>Prev Page</span></a
        >
      </ng-container>
      <ng-container *ngIf="reportService.firstPage">
        <i class="fa fa-arrow-left"></i><span>Prev Page</span>
      </ng-container>
    </div>
    <div class="embed-menu-item">
      <ng-container *ngIf="!reportService.lastPage">
        <a
          href="#"
          style="text-decoration: none; color: white"
          (click)="reportService.showNextPage()"
        ><span>Next Page</span><i class="fa fa-arrow-right"></i
        ></a>
      </ng-container>
      <ng-container *ngIf="reportService.lastPage">
        <span>Next Page</span><i class="fa fa-arrow-right"></i>
      </ng-container>
    </div>
    <div class="embed-menu-item">
      <a
        href="#"
        style="text-decoration: none; color: white"
        (click)="reportService.completeReport()"
      ><i class="fa fa-print"></i><span>Export</span></a
      >
    </div>
  </ng-container>
  <ng-container *ngIf="printPreview_IsActive">
    <div class="embed-menu-item" style="width: 250px; background-color: white; margin-bottom: 5px">
      <ng-container>
        <mat-select [(ngModel)]="printPreview_SelectedPageIndex" (selectionChange)="printPreviewPageSelectionChange($event)">
          <mat-option *ngFor="let page of printPreview_AvailablePages; let i = index" [value]="i">
            {{page.displayName}}
          </mat-option>
        </mat-select>
      </ng-container>
    </div>
    <div class="embed-menu-item">
      <ng-container *ngIf="printPreview_SelectedPageIndex != 0">
        <a href="#" style="text-decoration: none; color: white" (click)="printPreviewPrevPage()">
          <i class="fa fa-arrow-left"></i>
          <span>Prev Page</span>
        </a>
      </ng-container>
      <ng-container *ngIf="printPreview_SelectedPageIndex == 0">
        <i class="fa fa-arrow-left"></i><span>Prev Page</span>
      </ng-container>
    </div>
    <div class="embed-menu-item">
      <ng-container *ngIf="printPreview_SelectedPageIndex < (printPreview_AvailablePages.length - 1)">
        <a href="#" style="text-decoration: none; color: white" (click)="printPreviewNextPage()">
          <span>Next Page</span>
          <i class="fa fa-arrow-right"></i>
        </a>
      </ng-container>
      <ng-container *ngIf="printPreview_SelectedPageIndex == (printPreview_AvailablePages.length - 1)">
        <span>Next Page</span><i class="fa fa-arrow-right"></i>
      </ng-container>
    </div>
    <div *ngIf="printPreview_ShowCancel" class="embed-menu-item">
      <a href="#" style="text-decoration: none; color: white" (click)="printPreviewCancelClick()">
        <i class="fa fa-window-close"></i>
        <span *ngIf="!printOnDemand_Active">Back to Layout Config</span>
        <span *ngIf="printOnDemand_Active">Back to Config</span>
      </a>
    </div>
    <div *ngIf="printPreview_ShowSave" class="embed-menu-item">
      <a href="#" style="text-decoration: none; color: white" (click)="printPreviewSaveClick()">
        <i class="fa fa-save"></i>
        <span>Save Layout</span>
      </a>
    </div>
    <div *ngIf="printPreview_ShowPrint" class="embed-menu-item">
      <a href="#" style="text-decoration: none; color: white" (click)="printPreviewPrintClick()">
        <i class="fa fa-print"></i>
        <span *ngIf="!printOnDemand_Active">Save Layout & Print Now</span>
        <span *ngIf="printOnDemand_Active">Print Now</span>
      </a>
    </div>
  </ng-container>
</div>
<mat-menu #preFiltersMenu="matMenu" class="bookmarks-menu">
  <div>
    <table>
      <tr>
        <td>&nbsp;&nbsp;&nbsp;Clear Pre Filter</td>
        <td>
          <a href="#" (click)="clearPreFilter()"> [Clear] </a>
        </td>
      </tr>
      <ng-container *ngFor="let preFilter of userState.preFilters">
        <tr>
          <td>&nbsp;&nbsp;&nbsp;{{ preFilter.name }}</td>
          <td>
            <a href="#" (click)="applyPreFilter(preFilter.preFilterId)"><b> [Load] </b></a>
          </td>
        </tr>
      </ng-container>
    </table>
  </div>
</mat-menu>
<mat-menu #filtersMenu="matMenu" class="bookmarks-menu">
  <div>
    <table>
      <tr>
        <td colspan="4">
          <i class="fa fa-plus-square"></i
          ><a href="#" (click)="filterService.createFilter()"> Create New Filter...</a>
        </td>
      </tr>
      <tr>
        <td colspan="4">------------------------------</td>
      </tr>
      <ng-container *ngFor="let filter of filterService?.interactFilters">
        <ng-container *ngIf="filter.filterId !== 0">
          <tr>
            <td>&nbsp;&nbsp;&nbsp;{{ filter.name }}&nbsp;&nbsp;&nbsp;</td>
            <td>
              <a href="#" (click)="filterService.loadSelectedFilter(filter)"
              ><b> [Load] </b></a
              >
            </td>
            <td>
              <a
                *ngIf="filter.canEdit || filter.owner"
                href="#"
                (click)="filterService.editSelectedFilter(filter)"
              ><b> [Edit] </b></a>
            </td>
            <td>
              <a *ngIf="filter.owner" href="#" (click)="filterService.deleteSelectedFilter(filter)"
              ><b> [Delete] </b></a
              >
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </table>
  </div>
</mat-menu>
<mat-menu #reportsMenu="matMenu" class="bookmarks-menu">
  <div>
    <ng-container *ngFor="let report of reportService?.interactReports">
      <div class="bookmarks-menu-item">
        <i class="far fa-file"></i>
        <a href="#" (click)="reportService.startReport(report)">
          &nbsp;&nbsp;&nbsp;{{ report.name }}
        </a>
      </div>
    </ng-container>
  </div>
</mat-menu>
<mat-menu #bookmarksMenu="matMenu" class="bookmarks-menu">
  <div>
    <table>
      <tr>
        <td colspan="4">
          <i class="fa fa-plus-square"></i
          ><a href="#" (click)="bookmarkService.createBookmark()"> Create New Bookmark...</a>
        </td>
      </tr>
      <tr>
        <td colspan="4">------------------------------</td>
      </tr>
      <ng-container *ngFor="let bookmark of bookmarkService?.interactBookmarks">
        <ng-container *ngIf="bookmark.bookmarkId !== 0">
          <tr>
            <td>&nbsp;&nbsp;&nbsp;{{ bookmark.name }}</td>
            <td>
              <span
              >{{
                bookmark.createdBy ? "[" + bookmark.createdBy + "]" : ""
                }}&nbsp;&nbsp;&nbsp;</span
              >
            </td>
            <td>
              <a href="#" (click)="bookmarkService.loadSelectedBookmark(bookmark)"
              ><b> [Load] </b></a
              >
            </td>
            <td>
              <a
                *ngIf="bookmark.canEdit || bookmark.owner"
                href="#"
                (click)="bookmarkService.editSelectedBookmark(bookmark)"
              ><b> [Edit] </b></a
              >
            </td>
            <td>
              <a
                *ngIf="bookmark.owner"
                href="#"
                (click)="bookmarkService.deleteSelectedBookmark(bookmark)"
              ><b> [Delete] </b></a
              >
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </table>
  </div>
</mat-menu>
<mat-menu #interactivesMenu="matMenu" class="bookmarks-menu">
  <div>
    <table>
      <tr *ngFor="let interactive of availableInteractives">
        <td><i class="fas fa-chart-bar"></i>&nbsp;&nbsp;&nbsp;{{interactive.interactName}}&nbsp;&nbsp;&nbsp;</td>
        <td>{{ interactive.description }}&nbsp;&nbsp;&nbsp;</td>
        <td>Public Insight&nbsp;&nbsp;&nbsp;</td>
        <td><a href="#" (click)="interactiveView(interactive)">[View]&nbsp;&nbsp;&nbsp;</a></td>
        <td>
          <ng-container *ngIf="interactive.canCopy">
            <a href="#" (click)="interactiveCopyAndEdit(interactive)">[Copy &amp; Edit]&nbsp;&nbsp;&nbsp;</a>
          </ng-container>
          <ng-container *ngIf="interactive.canPreFilter">
            <a href="#" (click)="preFilteredInteractiveCreate(interactive)">[Create Pre-Filter]&nbsp;&nbsp;&nbsp;</a>
          </ng-container>
        </td>
        <td>&nbsp;&nbsp;&nbsp;</td>
      </tr>
      <tr *ngFor="let interactive of availableModifiedInteractives">
        <td><i class="fas fa-chart-bar"></i>&nbsp;&nbsp;&nbsp;{{ interactive.name }}&nbsp;&nbsp;&nbsp;</td>
        <td>{{ interactive.interactive.description }}&nbsp;&nbsp;&nbsp;</td>
        <td>{{ interactive.createdBy }}&nbsp;&nbsp;&nbsp;</td>
        <td><a href="#" (click)="modifiedInteractiveView(interactive)">[View]&nbsp;&nbsp;&nbsp;</a></td>
        <td>
          <ng-container *ngIf="interactive.allowEdit">
            <a href="#" (click)="modifiedInteractiveEdit(interactive)">[Edit]&nbsp;&nbsp;&nbsp;</a>
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="interactive.owner">
            <a href="#" (click)="modifiedInteractiveDelete(interactive)">[Delete]&nbsp;&nbsp;&nbsp;</a>
          </ng-container>
        </td>
      </tr>
      <!--<tr *ngFor="let interactive of availablePreFilteredInteractives">
        <td><i class="fas fa-chart-bar"></i>&nbsp;&nbsp;&nbsp;{{ interactive.name }}&nbsp;&nbsp;&nbsp;</td>
        <td>{{ interactive.interactive.description }}&nbsp;&nbsp;&nbsp;</td>
        <td>{{ interactive.createdBy }}&nbsp;&nbsp;&nbsp;</td>
        <td><a href="#" (click)="preFilterInteractiveView(interactive)">[View]&nbsp;&nbsp;&nbsp;</a></td>
        <td>
          <ng-container *ngIf="interactive.allowEdit">
            <a href="#" (click)="preFilterInteractiveEdit(interactive)">[Edit]&nbsp;&nbsp;&nbsp;</a>
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="interactive.owner">
            <a href="#" (click)="preFilterInteractiveDelete(interactive)">[Delete]&nbsp;&nbsp;&nbsp;</a>
          </ng-container>
        </td>
      </tr>-->
    </table>
  </div>
</mat-menu>
<mat-menu #podMenu="matMenu" class="bookmarks-menu">
  <div>
    <table>
      <tr>
        <td colspan="4">
          <i class="fa fa-print"></i>&nbsp;&nbsp;<a href="#" (click)="printOnDemand()">Print On Demand</a>
        </td>
      </tr>
      <!--<tr>
        <td colspan="4">
          <i class="fa fa-print"></i>&nbsp;&nbsp;<a href="#" (click)="printPreviewSelected()">Print Preview</a>
        </td>
      </tr>-->
      <tr>
        <td colspan="4">
          <i class="fa fa-save"></i>&nbsp;&nbsp;<a href="#" (click)="createLayoutSelected()">Create New Print Layout</a>
        </td>
      </tr>
      <tr *ngIf="podLayout && podLayout.allowEditing">
        <i class="fa fa-edit"></i>&nbsp;<a href="#" (click)="editCurrentLayout()">Edit Current Print Layout</a>
      </tr>
    </table>
  </div>
</mat-menu>
<ng-container>
  <div #pbiContainer class="displayNormal"></div>
  <div #pbiTempContainer style="display: none">
    <div style="display: flex">
      <div style="flex-grow: 1"></div>
      <div>
        <h1 style="color: white">
          Loading Interactive... <i class="fas fa-spinner fa-pulse"></i>
        </h1>
      </div>
      <div style="flex-grow: 1"></div>
    </div>
  </div>
</ng-container>
